/* Delivery date by PIN code.
   Order now -> 12-hour change window -> dispatched within 2 working days (no Sundays) -> courier transit by zone (no Sunday deliveries). */
(function(){
  var WINDOW_H=12, DISPATCH=[1,2];
  var ZONES=[
    {n:'Chennai',d:[1,2],t:function(p){return /^600/.test(p)}},
    {n:'North-East, J&K, Ladakh and the islands',d:[7,10],t:function(p){return /^(78|79|18|19|744|6825|737)/.test(p)}},
    {n:'Tamil Nadu and Puducherry',d:[2,3],t:function(p){return /^6[0-4]/.test(p)}},
    {n:'South India',d:[3,4],t:function(p){return /^(5[0-3]|5[6-9]|6[7-9])/.test(p)}},
    {n:'metro cities',d:[3,5],t:function(p){return /^(110|400|700|411|380|122|201)/.test(p)}},
    {n:'the rest of India',d:[4,7],t:function(){return true}}
  ];
  var KEY='mb_pin';
  function store(k,v){try{if(v===undefined)return localStorage.getItem(k);localStorage.setItem(k,v)}catch(e){return null}}
  function addWork(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);if(d.getDay()!==0)n--}return d}
  function fmt(d){return d.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'})}
  function estimate(pin){
    if(!/^[1-9]\d{5}$/.test(pin))return null;
    var z=ZONES.filter(function(x){return x.t(pin)})[0];
    var start=new Date(Date.now()+WINDOW_H*3600e3);
    var a=addWork(addWork(start,DISPATCH[0]),z.d[0]), b=addWork(addWork(start,DISPATCH[1]),z.d[1]);
    return {zone:z.n,from:a,to:b};
  }
  function paint(box,pin){
    var out=box.querySelector('[data-eta-out]'), e=estimate(pin);
    if(!pin){out.textContent='Enter your PIN code to see when it reaches you.';out.className='mb-eta__out';return}
    if(!e){out.textContent='Enter a valid 6-digit PIN code.';out.className='mb-eta__out is-err';return}
    out.innerHTML='Reaches <b>'+pin+'</b> between <b>'+fmt(e.from)+'</b> and <b>'+fmt(e.to)+'</b> if you order today.';
    out.className='mb-eta__out is-ok';
  }
  function init(box){
    if(box._eta)return;box._eta=1;
    var inp=box.querySelector('[data-eta-pin]'),saved=store(KEY)||'';
    if(saved){inp.value=saved;paint(box,saved)}
    var go=function(){var p=inp.value.replace(/\D/g,'');inp.value=p;if(/^[1-9]\d{5}$/.test(p))store(KEY,p);paint(box,p);
      document.querySelectorAll('[data-eta]').forEach(function(o){if(o!==box){o.querySelector('[data-eta-pin]').value=p;paint(o,p)}})};
    box.querySelector('[data-eta-go]').addEventListener('click',go);
    inp.addEventListener('keydown',function(ev){if(ev.key==='Enter'){ev.preventDefault();go()}});
    inp.addEventListener('input',function(){inp.value=inp.value.replace(/\D/g,'').slice(0,6);if(inp.value.length===6)go()});
  }
  function scan(){document.querySelectorAll('[data-eta]').forEach(init)}
  window.mbEta={estimate:estimate};
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('mb:cartdrawn',scan);
})();
